module.exports = __webpack_public_path__ + "img/04_kii_10.0b3b54cd.jpg";